import React__default, { forwardRef } from 'react';

const CustomReferenceDot = forwardRef(function CustomReferenceDot(props, ref) {
    return (React__default.createElement("circle", Object.assign({}, props, { ref: ref }),
        React__default.createElement("animate", { attributeName: "r", values: "4;8;4", dur: "2s", begin: "0s", repeatCount: "indefinite" })));
});

export { CustomReferenceDot as C };
